import Vue from 'vue'
import Select from 'element-ui/lib/select'
import Option from 'element-ui/lib/option'
import OptionGroup from 'element-ui/lib/option-group'
import Input from 'element-ui/lib/input'
import Icon from 'element-ui/lib/icon'
import Form from 'element-ui/lib/form'
import FormItem from 'element-ui/lib/form-item'

Vue.use(Select)
Vue.use(Option)
Vue.use(Input)
Vue.use(OptionGroup)
Vue.use(Icon)
Vue.use(Form)
Vue.use(FormItem)
